module.exports = __webpack_public_path__ + "img/my-gift.fd91b6c5.png";